import React from "react";
//import Anime from 'animejs/lib/anime.es'
import Anime from "react-anime";

export default function() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.191 51.239">
      <Anime
        easing="easeOutSine"
        duration={2000}
        strokeDashoffset={el => {
          let pathLength = 0;
          if (el.getTotalLength) {
            pathLength = el.getTotalLength();
            el.setAttribute("stroke-dasharray", pathLength);
          }
          return [pathLength, 0];
        }}
      >
        <path
          style={{
            fill: "none",
            stroke: "#FFF",
            strokeMiterlimit: 10,
            strokeWidth: "1.5px"
          }}
          d="M9.41,36.012c12.41-11.7,10.8,3.458,4.5,11.7,4.4-5.531,14.634-19.741,22.74-19.625,9.137.131-.45,12.765-3.18,17.164C35.8,43.7,52.728,24.921,56.119,28.125,61.011,32.747,44.057,43.8,47.888,49.11c8.909,1.322,16.448-14,22.974-17.856-.376,3.536-10.82,13.27-3.03,15.813C72.863,48.708,82.644,34.951,80.386,30.7c-2.959-5.566-16.42,1.47-11.422,6.934C75.61,44.9,82.913,29.5,86.7,31.047c-.789,2.985-3.071,10.3-2.045,13.29,3.437-4.666,4.7-10.77,10.921-12.373C97.719,31.413,112.9,34.6,111.72,27.5c-3.467-3.01-11.684,8.106-9.952,11.14,2.466,4.319,9.554-4.875,10.2-7.588-2.364,5.577-1.478,13.256-2.631,19.233a94.9,94.9,0,0,1-6.2,20.947c-2.4,5.252-5.386,8.777-5.218.832.144-6.8,4.85-13.417,8.557-18.809,4.245-6.173,9.835-10.806,14.657-16.457,1.737-2.035,8.142-11.638.647-6.831-2.2,1.408-5.867,9.434-2.757,10.735,4.069,1.7,7.365-9.091,9.182-10.5.083.592-1.863,10.257.623,8.943,3.423-1.81,2.877-8.469,6.743-10.7.883,2.9-2.6,6.137-1.4,9.008,2.575-2.314,3.9-7.062,7.547-8.184,4.27,4.124-.087,12.381,7.824,4.073"
          transform="translate(-8.896 -26.236)"
        />
      </Anime>
    </svg>
  );
}
